import { useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import styles from './search-area.scss';
import withEmbedded from 'root/hocs/withEmbedded';

const SearchArea = ({ onChange, onKeyDown, onBlur, shouldFocusOnInput, onFocus, query, t }) => {
  const searchInputRef = useRef(null);

  const handleChange = event => {
    let searchQuery = event.target.value || '';
    onChange(searchQuery);
  };

  const handleKeyDown = event => {
    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  const handleBlur = event => {
    // Call parent's onBlur handler if provided
    if (onBlur) {
      // Use setTimeout to allow click events to complete first
      setTimeout(() => {
        onBlur(event);
      }, 200);
    }
  };

  useEffect(() => {
    if (shouldFocusOnInput) {
      searchInputRef.current.focus();
    }
  }, [shouldFocusOnInput]);

  return (
    <div id="searchBlock" className={styles.searchArea} data-knowledgegraph-tutorial="step-3">
      <div className={styles.searchIcon} />
      <input
        type="text"
        autoComplete="off"
        id="SearchAreaInputHook"
        onChange={handleChange}
        onFocus={() => onFocus()}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        ref={searchInputRef}
        className={styles.searchAreaInput}
        placeholder={t('search')}
      />
    </div>
  );
};

export default withTranslation('veezoo')(withEmbedded(SearchArea));

SearchArea.propTypes = {
  onBlur: PropTypes.func, // Add prop for blur handling
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  shouldFocusOnInput: PropTypes.bool,
  query: PropTypes.string,
  t: PropTypes.func
};
